<template>
  <div class="common-layout">
    <el-container>
      <el-header style="height: 100%">
        <el-row>
          <el-col :span="4">
            <div>
              日期:{{this.parentData.production_date}}
            </div>
          </el-col>
          <el-col :span="4">
            <div>
              前处理面积(㎡):{{this.parentData.qcl_total_area}}
            </div>
            <div>
              喷涂面积(㎡):{{this.parentData.tz_total_area}}
            </div>
          </el-col>
          <el-col :span="4">
            <div>
              前处理框数:{{this.parentData.qcl_case_cnt}}
            </div>
            <div>
              喷涂框数:{{this.parentData.tz_case_cnt}}
            </div>
          </el-col>
          <el-col :span="4">
            <div>
              前处理人工:{{this.parentData.qcl_man_hour}}
            </div>
            <div>
              喷涂人工:{{this.parentData.tz_man_hour}}
            </div>
          </el-col>
          <el-col :span="4">
            <div>
              前处理框生产性:{{this.parentData.productive}}
            </div>
            <div>
              喷涂框生产性:{{this.parentData.productive1}}
            </div>
          </el-col>
          <el-col :span="4">
            <div>
              前处理生产性:{{this.parentData.productive2}}
            </div>
            <div>
              喷涂生产性:{{this.parentData.productive3}}
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-main>
        <frame-tab component-param="mfg_tz_produce_report_detail_tab" :init-data="this.parentData" :parent-data="{production_date:this.parentData.production_date}"></frame-tab>
      </el-main>
    </el-container>
  </div>

</template>

<script>
export default {
  name: "MfgTzProduceReportDetail",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
}
</script>

<style scoped>

.vertical-centered-header {
  display: flex;
  align-items: center;
  height: 100%;
}

</style>